module.exports = __webpack_public_path__ + "img/php.93d6dcb9.svg";